import Compressor from 'compressorjs';

export const compressImage = async (
	file: File,
	setImage: (image: string) => void,
	setFile: (file: File) => void,
	setResizedFile: (file: File) => void
) => {
	new Compressor(file, {
		quality: 0.3, // its not recommended to go below 0.6 .
		success: (compressedResult) => {
			const url = URL.createObjectURL(compressedResult);
			setImage(url);
			const compressedFile = new File([compressedResult], file.name);
			setFile(compressedFile);
		}
	});

	new Compressor(file, {
		quality: 0.8, // the quality of the image, max is 1,
		maxWidth: 400, // the max width of the output image, defaults to 1920px
		maxHeight: 400, // the max height of the output image, defaults to 1920px
		resize: 'contain', // defaults to true, set false if you do not want to resize the image width and height

		success: (compressedResult) => {
			const compressedFile = new File([compressedResult], file.name);
			setResizedFile(compressedFile);
		}
	});
};
